class BfProductStockCounter extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;

    this.dataset.initialized = 'true';
    this.stockCountElement = this.querySelector('[data-bf-stock-count]');
    this.stockSquaresElement = this.querySelector('[data-bf-stock-squares]');
    this.productHandle = this.dataset.productHandle;
    this.timeoutId = null;

    if (!this.stockCountElement || !this.stockSquaresElement || !this.productHandle) return;

    this.stockKey = `stockCount_${this.productHandle}`;
    this.expiryKey = `stockExpiry_${this.productHandle}`;
    this.expiryTime = 24 * 60 * 60 * 1000;

    this.stockCount = this.getStoredStockCount();
    if (this.stockCount === null) {
      this.stockCount = this.getRandomInteger(23, 48);
      this.storeStockCount(this.stockCount);
    }

    this.updateDisplay();
    this.scheduleDecrease();
  }

  disconnectedCallback() {
    if (this.timeoutId) {
      window.clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }

  getStoredStockCount() {
    try {
      const storedStock = window.localStorage.getItem(this.stockKey);
      const storedExpiry = window.localStorage.getItem(this.expiryKey);
      if (!storedStock || !storedExpiry) return null;

      const now = Date.now();
      if (now >= Number(storedExpiry)) return null;

      return Number.parseInt(storedStock, 10);
    } catch (_error) {
      return null;
    }
  }

  storeStockCount(stockCount) {
    try {
      window.localStorage.setItem(this.stockKey, String(stockCount));
      window.localStorage.setItem(this.expiryKey, String(Date.now() + this.expiryTime));
    } catch (_error) {
      // Ignore storage failures and keep the in-memory value.
    }
  }

  updateDisplay() {
    this.stockCountElement.textContent = String(this.stockCount);
    this.stockSquaresElement.innerHTML = '';

    for (let index = 0; index < 5; index += 1) {
      const square = document.createElement('div');
      square.classList.add('square');
      if (index === 0) {
        square.classList.add('filled');
      }
      this.stockSquaresElement.appendChild(square);
    }
  }

  scheduleDecrease() {
    if (this.stockCount <= 5) return;

    this.timeoutId = window.setTimeout(() => {
      if (this.stockCount > 5) {
        this.stockCount -= this.getRandomInteger(1, 2);
        if (this.stockCount < 5) {
          this.stockCount = 5;
        }
        this.storeStockCount(this.stockCount);
        this.updateDisplay();
      }

      this.scheduleDecrease();
    }, this.getRandomInteger(60000, 120000));
  }

  getRandomInteger(minimum, maximum) {
    return Math.floor(Math.random() * (maximum - minimum + 1)) + minimum;
  }
}

class BfProductShippingBanner extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;

    this.dataset.initialized = 'true';
    this.locationElement = this.querySelector('[data-bf-location-text]');
    this.defaultLocation = this.dataset.defaultLocation || 'United States';
    this.apiKey = this.dataset.apiKey;

    if (!this.locationElement || !this.apiKey) return;

    this.locationElement.textContent = this.defaultLocation;

    fetch(`https://pro.ip-api.com/json/?fields=status,country,countryCode,regionName,city&key=${this.apiKey}`)
      .then((response) => response.json())
      .then((data) => {
        if (data.status !== 'success') return;

        if (data.countryCode === 'US') {
          this.locationElement.textContent = data.city || data.regionName || this.defaultLocation;
        } else {
          this.locationElement.textContent = this.defaultLocation;
        }
      })
      .catch(() => {
        this.locationElement.textContent = this.defaultLocation;
      });
  }
}

if (!customElements.get('bf-product-stock-counter')) {
  customElements.define('bf-product-stock-counter', BfProductStockCounter);
}

if (!customElements.get('bf-product-shipping-banner')) {
  customElements.define('bf-product-shipping-banner', BfProductShippingBanner);
}
